module.exports = __webpack_public_path__ + "img/new_friend.3ebb7570.png";